import AbstractMapper from '@core/utils/mappers/AbstractMapper';
import ISpecialOddTypeDto, { ISpecialOddTypeIncompleteDto } from '@core/mappers/specials/dtos/ISpecialOddTypeDto';
import SpecialMarketEvent, { SpecialMarketEventIncomplete } from '@core/models/specials/SpecialMarketEvent';
import SpecialOddMapper from '@core/mappers/specials/SpecialOddMapper';
import MatchRuleMapper from '@core/mappers/offer/MatchRuleMapper';

const specialOddMapper: SpecialOddMapper = new SpecialOddMapper();
const ruleMapper: MatchRuleMapper = new MatchRuleMapper();

type Input = ISpecialOddTypeDto | ISpecialOddTypeIncompleteDto;
type Output = SpecialMarketEvent | SpecialMarketEventIncomplete;
export default class SpecialMarketEventMapper extends AbstractMapper<Input, Output> {

    createTargetObject(dto: Input, options?: { fieldDefinitions:  string[] }) {
        const specialMarketEvent = {
            betStart: this.toDate(dto.betStart, { assumeUtc: true }),
            betEnd: this.toDate(dto.betStop, { assumeUtc: true }),
        };

        if (!this.isFullOddType(dto)) {
            return new SpecialMarketEventIncomplete(specialMarketEvent);
        }

        const fieldDefinitions = options!.fieldDefinitions;
        const numberOfValidOdds = fieldDefinitions.length;

        return new SpecialMarketEvent({
            ...specialMarketEvent,
            fieldDefinitions,
            id: dto.oddTypeId,
            code: dto.code,
            name: this.extractLocalizedString(dto.oddTypeName),
            specialBetValue: dto.sbVal || '',
            dateTime: this.toDate(dto.offerDateTime, { assumeUtc: true }),
            odds: dto.odds
                .slice(0, numberOfValidOdds)
                .map((odd, index) =>
                    specialOddMapper.createTargetObject(odd, { oddName: options!.fieldDefinitions[index] })
                ),
            rules: ruleMapper.map(dto.rules, true),
        });

    }

    private isFullOddType(oddType: Input): oddType is ISpecialOddTypeDto {
        return oddType.hasOwnProperty('oddTypeName');
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/mappers/specials/SpecialMarketEventMapper.ts